import handleTeamAssistV2Error from 'actions/team_assist_v2/lib/handle_team_assist_v2_error';
import { abortRequests } from 'actions/team_assist_v2/lib/in_flight_team_assist_v2_requests';
import isTeamAssistV2Enabled from 'actions/team_assist_v2/lib/is_team_assist_v2_enabled';
import RequestTeamAssistV2 from 'actions/team_assist_v2/request_team_assist_v2';

export default class ClearTeamAssistV2 {
  constructor(context) {
    this.context = context;
  }

  run({ customerId }) {
    if (!isTeamAssistV2Enabled(this.context.stores.appFeatures.get())) {
      return;
    }
    if (!customerId || !this.context.stores.customers.has({ id: customerId })) {
      return;
    }
    const store = this.context.stores.customers.storesFor(customerId).teamAssistsV2;
    if (store.isClearing()) {
      return;
    }
    abortRequests(customerId);
    store.set([]);
    store.resetLoading();
    store.clearErrorForLoading();

    // Until the DELETE answers, Ask and session loads hold off: glados still
    // has the session being cleared active. The flag sits outside the
    // customer's data, so it's reset even if the customer is unloaded meanwhile.
    store.setClearing();
    return this.context.gateways.teamAssistV2
      .clear({ customerId })
      .finally(() => store.resetClearing())
      .catch(err => this.onClearFailed(customerId, err));
  }

  // The session is still active, so its turns come back.
  onClearFailed(customerId, err) {
    handleTeamAssistV2Error(this.context, err, { isInteractive: true });
    this.context.executeAction(RequestTeamAssistV2, { customerId });
  }
}
